import { render, staticRenderFns } from "./AboutMiniTcdc.vue?vue&type=template&id=16e8286e&scoped=true"
import script from "./AboutMiniTcdc.vue?vue&type=script&lang=js"
export * from "./AboutMiniTcdc.vue?vue&type=script&lang=js"
import style0 from "./AboutMiniTcdc.vue?vue&type=style&index=0&id=16e8286e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e8286e",
  null
  
)

export default component.exports